import { Flex, Title, Text } from "@mantine/core";
import { LoginMessageProps } from "../../types";
import { getBankIdFailureMessage } from "../../utils/bankIdFailureMessages";

export function LoginMessage({ status, processStatusInfo }: LoginMessageProps) {
  const isFailed = status === "failed";

  const defaultMessage = {
    title: "Välkommen till Mina sidor!",
    text: `Här följer du dina ärenden och kan se alla viktiga dokument samlade 
        på ett och samma ställe.`,
  };

  const failureMessage = getBankIdFailureMessage(processStatusInfo);

  const { title, text } = isFailed
    ? { title: failureMessage.title, text: failureMessage.text }
    : defaultMessage;

  const content = (
    <>
      <Title
        order={1}
        size="h2"
        mb="md"
        ff="var(--wallet-font-family-sambla-sans)"
      >
        {title}
      </Title>
      <Text>{text}</Text>
    </>
  );

  return (
    <Flex direction="column" w="100%">
      {isFailed ? <div role="alert">{content}</div> : content}
    </Flex>
  );
}
